import storeMapper from "~/mixins/storeMappers/storeMapper";
import selectedMixin from "./selectedMixin";
import ObjectModelPermissionPermittee from "~/models/objectModelPermissionPermittee";

const permissionPermitteesStoreMixin = storeMapper('objectModelStore', {
  state: [
    'filterPermissionPermitteeClientIds',
  ],
});

export default {
  mixins: [
    selectedMixin,
    permissionPermitteesStoreMixin,
  ],
  computed: {
    permissionsTablePermittees(): ObjectModelPermissionPermittee[] {
      return this.selectedObjectModel.permissionPermitteesArray.filter(permittee => {
        return this.filterPermissionPermitteeClientIds.includes(permittee.client_id);
      });
    },
  },
}